
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 4.594v22.813l-1.719-1.688L8.562 21H3.999V11h4.563l4.719-4.719zm9.125 1.781C26.51 8.886 28 12.271 28 16s-1.49 7.113-3.875 9.625l-1.406-1.406C24.743 22.07 26 19.178 26 16s-1.257-6.071-3.281-8.219zm-2.812 2.813c1.661 1.786 2.688 4.187 2.688 6.813s-1.026 5.026-2.688 6.813l-1.406-1.438c1.3-1.424 2.094-3.3 2.094-5.375s-.794-3.952-2.094-5.375zM13 9.438l-3.281 3.281-.313.281H6v6h3.406l.313.281L13 22.562V9.437zm5.5 2.593C19.439 13.09 20 14.477 20 16s-.561 2.91-1.5 3.969l-1.438-1.438C17.64 17.837 18 16.972 18 16s-.36-1.837-.938-2.531z"}})])
          )
        }
      }
    